<template>
  <Profile />
</template>
<script>
import Profile from '@/components/auth/Profile.vue'
export default {
  name: 'ProfileView',
  components: {
    Profile,
  },
}
</script>
<style lang="scss" scoped></style>
